export default class BCMSDispatchHandler {

    _id; // This is the name of the handler
    _fn; // This is the function that will be used to dispatch events

    // CONSTUCTOR :: STRING, (state, action -> state) -> BCMSDispatcherHandler
    // Set the properties of "id" and "fn"
    constructor(id, fn){
        this.id = id;
        this.fn = fn;
    }

    // id :: * -> VOID
    // Setter for id
    set id(val){
        if(typeof val == "string"){
            this._id = val;
        }else{
            throw new Error("ID of BCMSDispatchHandler must be STRING");
        }
    }

    // fn :: * -> VOID
    // Setter for fn
    set fn(val){
        if(val instanceof Function){
            this._fn = (state, action) => {
                try {
                    let result = val(state, action);

                    if(result instanceof Object){
                        return result;
                    }
                    else{
                        throw new Error(`Result of handler function must be an OBJECT, "${result}" returned instead`);
                    }
                } catch(err) {
                    throw new Error(err);
                }
            };
        }else{
            throw new Error("FN of BCMSDispatchHandler must be FUNCTION");
        }
    }

    // id :: * -> STRING
    // Getter for id
    get id() {
        return this._id;
    }

    // fn :: * -> FUNCTIOn
    // Getter for fn
    get fn() {
        return this._fn;
    }

    get self() {
        return { [this._id] : this._fn }
    }

    // init :: (STRING, FUNCTION) -> BCMSDispatcherHandler
    // Returns a new BCMSDispatcherHandler
    static init(id, fn){
        return new BCMSDispatchHandler(id, fn);
    }
}